import React from 'react';

const DRIVE_FOLDER_LINK = "https://drive.google.com/embeddedfolderview?id=1PnuXStcoFdPV-BNPM7l1XkMMgvJyVA-t#grid";

export const QuestionPaperModal = ({ grade, onClose }) => {
  if (grade === null || grade === undefined) return null;

  return (
    <div
      id="paper-modal"
      className="fixed inset-0 z-50 overflow-y-auto select-none"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
          onClick={onClose}
        ></div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        {/* Modal dialog */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full h-[90vh]">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 h-full flex flex-col">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                Question Paper{' '}
                <span id="modal-grade-badge" className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded-full font-bold">
                  {grade !== 'all' ? `Grade ${grade}` : 'All Grades'}
                </span>
              </h3>
              <button
                type="button"
                className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none cursor-pointer"
                onClick={onClose}
              >
                <span className="sr-only">Close</span>
                <span className="text-2xl font-bold">&times;</span>
              </button>
            </div>
            <div className="flex-1 bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 overflow-hidden relative">
              <iframe
                id="modal-paper-frame"
                className="w-full h-full bg-white"
                src={DRIVE_FOLDER_LINK}
                title="Question Paper Document Frame"
                frameBorder="0"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default QuestionPaperModal;
